
function toggleFold(index) {
	let $fold = $w('#folded' + index);
	let $box = $w('#box' + index);
	let $boxOn = $w('#boxOn' + index);
	// toggle the fold at the index
	if ($fold.collapsed) {
		$fold.expand();
		$boxOn.show();
		$box.hide();
	}
	else {
		$fold.collapse();
		$boxOn.hide();
		$box.show();
	}
	// collapse the other folds
	[1,2,3,4,5,6,7,8,9]
		.filter(idx => idx !== index)
		.forEach(idx => {
			$w('#folded' + idx).collapse();
			$w('#box' + idx).show();
			//$w('#boxOn' + idx).collapse();		
		})
}


export function box1_click(event) {
    toggleFold(1);
}

export function box2_click(event) {
	toggleFold(2);
}

export function box3_click(event) {
	toggleFold(3);
}

export function box4_click(event) {
    toggleFold(4);
}

export function box5_click(event) {
    toggleFold(5);
}

export function box6_click(event) {
    toggleFold(6);
}

export function box7_click(event) {
    toggleFold(7);
}

export function box8_click(event) {
    toggleFold(8);
}

export function box9_click(event) {
    toggleFold(9);
}